
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 14.25a6 6 0 00-6-5.25 6 6 0 00-6 5.25M3.375 4.125a3.375 3.375 0 106.75 0 3.375 3.375 0 10-6.75 0zm10.5-.75a2.625 2.625 0 105.25 0 2.625 2.625 0 10-5.25 0zm6.013 4.915a4.5 4.5 0 00-6.776 0m1.138 7.46h9v7.5h-9zm4.5-4.5h0a3 3 0 00-3 3v1.5h6v-1.5a3 3 0 00-3-3zm0 7.904h0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M18.75 19.154a.375.375 0 10.375.375.374.374 0 00-.375-.375","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    